import {
  Button,
  Card,
  Flex,
  Form,
  Input,
  Modal,
  Select,
  Typography,
} from "antd";
import React, { useRef } from "react";
import { CustomTitle } from "../../../../common/customTitle";
import { useState } from "react";
import { useDispatch } from "react-redux";
import RequiredLabel from "../../../../common/required-label/RequiredLabel";
import { useTranslation } from "react-i18next";
import TextArea from "antd/es/input/TextArea";
import { checkIfFileTypeIsValidForImageAttachment, sanitizeDataTypeClientSide } from "../../../../../utils/utils";
import { useEffect } from "react";
import Actions from "../../../../../redux/actions";
import { fileImageUpload } from "../../../../../redux/services/auth/authServices";
import { FileAttachment } from "../../../../common/fileAttachment";
import { CameraOutlined } from "@ant-design/icons";
import { colors } from "../../../../../constants/colors";
import {
  createFlashMessagesAction,
  getFlashMessageByIdAction,
  updateFlashMessagesAction,
} from "../../../../../redux/services/flash-message/flashMessageServices";
import { appConstConfig } from "../../../../../constants/config/appConstConfig";
import { appAssetsConfig } from "../../../../../constants/config/appAssetsConfig";
import { toastService } from "../../../../common/toast-messages/toast";

const FlashMessageFormDialog = ({
  open,
  onClose,
  selectedListData,
  setSelectedListData,
}) => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* form dependencies */
  const [form] = Form.useForm();
  /* form dependencies */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  const [imageLoader, setImageLoader] = useState(false);
  /* module dependencies for attachment - single */
  const [singleAttachmentObj, setSingleAttachmentObj] = useState(null);
  const [singleAttachmetSelectedImageUrl, setSingleAttachmetSelectedImageUrl] =
    useState("");
  const attachmentRef = useRef(null);
  /* module dependencies for attachment - single */

  /* on Image changed- single attachment */
  const onImageChanged = (e) => {
    const file = e.target.files[0];

    const attachmentFileName = file.name;

    const fileTypeIsValidRes = checkIfFileTypeIsValidForImageAttachment(attachmentFileName);

    if (fileTypeIsValidRes.isValid === false) {
      toastService.error(fileTypeIsValidRes.isInvalidMessage);
    } else {
      setSingleAttachmentObj(file);
    if (file) {
      const formData = new FormData();
      formData.append("image", file);
      let formDataBody = formData;
      setImageLoader(true);
      dispatch(fileImageUpload(formDataBody)).then((apiRes) => {
        const imageUrl = apiRes?.[0];
        setSingleAttachmetSelectedImageUrl(imageUrl);
        setImageLoader(false);
      });
    }
    }
  };
  
  /* dialog close dependencies */
  const handleDialogClose = () => {
    onClose();
    form.resetFields();
    dispatch(
      Actions.createAction(Actions.SELECTED_FLASH_MESSAGE_ID, {
        selectedFlashMessageId: "",
      })
    );
    setSelectedListData(null);
    setSingleAttachmetSelectedImageUrl("");
    setSingleAttachmentObj(null);
  };
  /* dialog close dependencies */

  useEffect(() => {
    if (selectedListData) {
      setLoading(true);

      const dataToBeSent = {
        selectedFlashMessageId: selectedListData?._id,
      };
      dispatch(getFlashMessageByIdAction(dataToBeSent, setLoading)).then((apiRes) => {
        const locale = apiRes?.locales[0];
        form.setFieldsValue({
          title: apiRes?.title,
          body: apiRes?.body,
          title_ar: locale?.title || "",
          body_ar: locale?.body || "",
          tags: apiRes?.tags?.map((s) => s),
        });
        setSingleAttachmetSelectedImageUrl(apiRes?.coverimage || "");
      });

    }

    return () => {
      setSingleAttachmetSelectedImageUrl("");
    };
  }, [form, selectedListData]);


  const onSubmit = (values) => {
    const dataToBeSent = {
      ...values,
      coverimage: singleAttachmetSelectedImageUrl,
    };
    if (selectedListData?.hasOwnProperty("_id")) {
      dataToBeSent._id = selectedListData?._id;
      dispatch(updateFlashMessagesAction(dataToBeSent, setLoading)).then(() => {
        handleDialogClose();
      });
    } else {
      dispatch(createFlashMessagesAction(dataToBeSent, setLoading)).then(() => {
        handleDialogClose();
      });
    }
  };

  return (
    <Modal
      open={open}
      onCancel={handleDialogClose}
      footer={false}
      confirmLoading={loading}
      style={{ top: 20 }}
    >
      <CustomTitle textDecoration="underline" justifyContent="center">
        {!selectedListData || !selectedListData?._id
          ? t("AppModuleNames.SuperAdmin.AddFlashMessage")
          : t("AppModuleNames.SuperAdmin.EditFlashMessage")}
      </CustomTitle>
      <Form
        form={form}
        layout="vertical"
        autoComplete="off"
        requiredMark={false}
        onFinish={onSubmit}
        style={{ margin: "2rem" }}
      >
        <Flex vertical gap="2rem">
          <Flex vertical gap="2rem" align="center">
            <Flex
              vertical
              align="center"
              justify="center"
              style={{ position: "relative" }}
            >
              <FileAttachment
                attachmentObj={singleAttachmentObj}
                attachmentUrl={singleAttachmetSelectedImageUrl}
                loading={imageLoader}
              />
              <div
                className="attachmentContainer"
                style={{
                  cursor: "pointer",
                  position: "absolute",
                  bottom: "-25px",
                  background:colors.turquoiseGreen,
                  borderRadius:10,
                }}
                onClick={() => attachmentRef.current?.click()}
              >
                <Button
                  type="primary"
                  shape="circle"
                  size="middle"
                  style={{ background:colors.turquoiseGreen}}
                  icon={<CameraOutlined style={{ fontSize: "22px" }} />}
                />
              </div>
              <input
                type="file"
                style={{ display: "none" }}
                ref={attachmentRef}
                accept="image/*"
                onChange={onImageChanged}
              />
            </Flex>
            <Typography.Title
              level={3}
              type="secondary"
              style={{ marginBottom: 10 }}
            >
              {t("CommonUtils.supportedImageFormats")}
            </Typography.Title>
          </Flex>

          <Card bordered>
            <Form.Item
              style={{ width: "100%" }}
              name="title"
              label={
                <RequiredLabel
                  text={t("Modules.Notify.title")}
                  required={true}
                />
              }
              rules={[
                {
                  required: true,
                  message: t("Modules.Notify.pleaseEnterTitle"),
                },
                {
                  whitespace: true,
                  message: t("Modules.Notify.pleaseEnterTitle"),
                },
              ]}
              normalize={(value) => sanitizeDataTypeClientSide(value)}
            >
              <Input placeholder={t("Modules.Notify.enterTitle")} />
            </Form.Item>

            <Form.Item
              style={{ width: "100%" }}
              name="title_ar"
              label={
                <RequiredLabel
                  text={`${t("Modules.Notify.title")} ${t("CommonUtils.inArabic")}`}
                  required={true}
                />
              }
              rules={[
                {
                  required: true,
                  message: `${t("Modules.Notify.pleaseEnterTitle")} ${t("CommonUtils.inArabic")}`,
                },
                {
                  whitespace: true,
                  message: `${t("Modules.Notify.pleaseEnterTitle")} ${t("CommonUtils.inArabic")}`,
                },
              ]}
              normalize={(value) => sanitizeDataTypeClientSide(value)}
            >
              <Input dir="rtl" placeholder={`${t("Modules.Notify.enterTitle")} ${t("CommonUtils.inArabic")}`} />
            </Form.Item>

            <Form.Item
              label={<RequiredLabel text={t("body")} required={true} />}
              name="body"
              rules={[
                {
                  required: true,
                  message: t("Modules.Notify.bodyCannotBeEmpty"),
                },
                {
                  whitespace: true,
                  message: t("Modules.Notify.bodyCannotBeEmpty"),
                },
              ]}
              normalize={(value) => sanitizeDataTypeClientSide(value)}
            >
              <TextArea
                rows={4}
                showCount
                maxLength={
                  appConstConfig.DEFAULT_CHARACTERS_ALLOWED_FOR_TEXTAREA
                }
                placeholder={t("validations.body")}
              />
            </Form.Item>

            <Form.Item
              label={
                <RequiredLabel text={`${t("body")} ${t("CommonUtils.inArabic")}`} required={true} />
              }
              name="body_ar"
              rules={[
                {
                  required: true,
                  message: `${t("Modules.Notify.bodyCannotBeEmpty")} ${t("CommonUtils.inArabic")}`,
                },
                {
                  whitespace: true,
                  message: `${t("Modules.Notify.bodyCannotBeEmpty")} ${t("CommonUtils.inArabic")}`,
                },
              ]}
              normalize={(value) => sanitizeDataTypeClientSide(value)}
            >
              <TextArea
                dir="rtl"
                rows={4}
                showCount
                maxLength={
                  appConstConfig.DEFAULT_CHARACTERS_ALLOWED_FOR_TEXTAREA
                }
                placeholder={`${t("validations.body")} ${t("CommonUtils.inArabic")}`}
              />
            </Form.Item>

            {/* <Form.Item
              label={<RequiredLabel text="Tags" required={true} />}
              name="tags"
              rules={[
                {
                  required: true,
                  message: "Please enter tags",
                },
              ]}
            >
              <Select
                mode="tags"
                style={{ width: "100%" }}
                placeholder="Enter Tags"
                options={[]}
              />
            </Form.Item> */}
          </Card>
        </Flex>

        <Flex gap="1rem" align="center" justify="center">
          <Button
            type="primary"
            htmlType="submit"
            style={{ marginTop: "1rem" }}
            loading={loading}
            disabled={loading}
          >
            {t("CommonUtils.submit")}
          </Button>
        </Flex>
      </Form>
    </Modal>
  );
};

export default FlashMessageFormDialog;
